import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import { updatePassword } from '../../api/authenticationApi';
import { updateStudentPassword } from '../../api/admissionApi';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Setting extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			currentPassword: '',
			newPassword: '',
			confPassword: ''
		};
	}

	resetState = () => {
		this.setState({
			currentPassword: '',
			newPassword: '',
			confPassword: ''
		})
	}

	warnNotification = (displayText) => toast.warn(displayText, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: true,
		progress: undefined,
	});

	onClickUpdate = () => {
		const { currentPassword, newPassword, confPassword } = this.state;
		const { facultyId = '', updatePassword, studentEmail = '', updateStudentPassword, isStudent } = this.props;
		const sameCurr = currentPassword === newPassword;
		const diffNew = newPassword !== confPassword;
		if (sameCurr || diffNew) {
			let displayText = "";

			if (sameCurr) {
				displayText = "Current password and New password can not be same";
			} else if (diffNew) {
				displayText = "New password and re-entered password are not same";
			}

			this.warnNotification(displayText);
		} else {
			const payload = {
				password: currentPassword,
				updatedPassword: newPassword
			};

			if (!isStudent) {
				payload.faculty_id = facultyId;
			} else {
				payload.email_id = studentEmail;
			}

			const callbacks = {
				updateSuccessCallback: this.updateSuccess,
				updateFailureCallback: this.updateFailure,
			};

			if (isStudent) {
				updateStudentPassword(payload, callbacks);
			} else {
				updatePassword(payload, callbacks);
			}
		}
	};

	updateSuccess = () => {
		toast.success(
			"Password updated successfully. Redirecting to dashboard...",
			{
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: false,
				progress: undefined,
				onClose: this.resetState
			}
		);
	};

	updateFailure = (msg = '') => {
		toast.error(msg, {
			position: "top-right",
			autoClose: 2000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: false,
			progress: undefined,
		});
	};

	render() {
		const { activeTab, confPassword, currentPassword, newPassword } = this.state
		const { facultyId = '', studentEmail = '', isStudent, passwordUpdating, studentPassUpdating } = this.props;
		const id = isStudent ? studentEmail : facultyId;
		const disabled = !confPassword || !currentPassword || !newPassword || !id;
		return (
			<Fragment>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Password Settings</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><span>St. Andrews College</span></li>
									<li className="breadcrumb-item active" aria-current="page">Change Password</li>
								</ol>
							</div>

							<Nav tabs className="page-header-tab">
								<NavItem>
									<NavLink
										className={classnames({ active: activeTab === 1 })}
										onClick={() => this.setState({ activeTab: 1 })}
									>
										Change Password
									</NavLink>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>
				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>
							<TabPane tabId={1} className={classnames(['fade show'])}>
								<div className="card">
									<div className="card-header">
										<h3 className="card-title">Password Settings</h3>
									</div>
									<div className="card-body">
										<form>
											<div className="column">
												<div className="col-md-4 col-sm-12">
													<div className="form-group">
														<label>{isStudent ? 'Student Email' : 'Faculty Id'}<span className="text-danger">*</span></label>
														<input className="form-control" type="text" value={id} disabled />
													</div>
												</div>
												<div className="col-md-4 col-sm-12">
													<div className="form-group">
														<label>Current Password<span className="text-danger">*</span></label>
														<input className="form-control" type="password" value={this.state.currentPassword} onChange={(e) => this.setState({ currentPassword: e.target.value })} />
													</div>
												</div>
												<div className="col-md-4 col-sm-12">
													<div className="form-group">
														<label>New Password<span className="text-danger">*</span></label>
														<input className="form-control" type="password" value={this.state.newPassword} onChange={(e) => this.setState({ newPassword: e.target.value })} />
													</div>
												</div>
												<div className="col-md-4 col-sm-12">
													<div className="form-group">
														<label>Re-enter New Password<span className="text-danger">*</span></label>
														<input className="form-control" type="password" value={this.state.confPassword} onChange={(e) => this.setState({ confPassword: e.target.value })} />
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-sm-12 text-right m-t-20">
													<button
														type="button"
														className="btn btn-primary"
														onClick={this.onClickUpdate}
														disabled={passwordUpdating || disabled || studentPassUpdating}
													>
														{(passwordUpdating || studentPassUpdating) ? <i className="fa fa-circle-o-notch fa-spin fa-fw"></i> : 'Update'}
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</TabPane>
						</TabContent>
					</div>
				</div>
				<ToastContainer />
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	facultyId: state.authenticationReducer.faculty_id,
	studentEmail: state.authenticationReducer.studentProfile.email_id,
	isStudent: state.authenticationReducer.studentProfile.isStudent,
	passwordUpdating: state.authenticationReducer.passwordUpdating,
	studentPassUpdating: state.admissionReducer.studentPassUpdating
});

const mapDispatchToProps = (dispatch) => ({
	updatePassword: (e, cb) => dispatch(updatePassword(e, cb)),
	updateStudentPassword: (e, cb) => dispatch(updateStudentPassword(e, cb))
});
export default connect(mapStateToProps, mapDispatchToProps)(Setting);
